import { Component, OnInit } from '@angular/core';
import { ClientRefillsService } from 'src/app/services/apiclient/clientrefills/clientrefills.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-invoice-recharge',
  templateUrl: './invoice-recharge.component.html',
  styleUrls: ['./invoice-recharge.component.css']
})
export class InvoiceRechargeComponent implements OnInit {

  recharge: any;
  loader: boolean = true;

  constructor(
    private refillsApi: ClientRefillsService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.checkUrlParams();
  }

  checkUrlParams() {

    this.route.params.subscribe((params:any)=> {

      this.refillsApi.getRecharge(params.userKey, params.rechargeId).subscribe(data => {

        this.recharge = data;
        this.loader = false;

      });

    });
  }

}
